(ns manage.poi.selectors.columns
  (:require [manage.poi.shared :refer [delete-action-column render-label-chips]]))

(defn selector-columns [on-delete]
  #js [#js {:field "name"
            :headerName "Name"
            :flex 1
            :valueGetter (fn [_ row] (:name row))}
       #js {:field "archived"
            :headerName "Archived"
            :width 100
            :type "boolean"
            :valueGetter (fn [_ row] (:archived row))}
       #js {:field "anyLabels"
            :headerName "Include POI with any of"
            :flex 1
            :sortable false
            :valueGetter (fn [_ row] (get-in row [:data :any-labels]))
            :renderCell render-label-chips}
       #js {:field "allLabels"
            :headerName "Include POI with all of"
            :flex 1
            :sortable false
            :valueGetter (fn [_ row] (get-in row [:data :all-labels]))
            :renderCell render-label-chips}
       #js {:field "notAnyLabels"
            :headerName "Exclude POI with any of"
            :flex 1
            :sortable false
            :valueGetter (fn [_ row] (get-in row [:data :not-any-labels]))
            :renderCell render-label-chips}
       ;; XXX not-all-labels not shown on purpose
       (delete-action-column on-delete
                             (fn [row] {:selector-id (:id row)
                                        :selector-name (:name row)}))])

(defn get-selector-id [row]
  (:id row))
